import { getDefectPhoto } from '@/api/rc/PWR02G06'
import {
  getWorkNoList,
  getmBuildList,
  urgeAndMailOneByParams,
  urgeAndMailOneByParamsOne,
  getReportRcInfo,
  getReportFile,
  getReportInfo,
} from '@/api/rc/PWR02G06'
export default {
  data() {
    return {
      defectFold: true,
      showBtn: true,
      unimplementFold: true,
      equipmentFold: true,
      workImplementInfos: [],
      uploadFileList: [],
      btnData: {
        show: true,
      },
      adjSourceClass: this.$divisions.adjSourceClassEnum.enum_1.value,
      preList: [
        this.$divisions.reportStatusEnum.enum_00.value,
        this.$divisions.reportStatusEnum.enum_01.value,
        this.$divisions.reportStatusEnum.enum_02.value,
        this.$divisions.reportStatusEnum.enum_03.value,
        this.$divisions.reportStatusEnum.enum_04.value,
      ],
      officalReportLimit: [
        this.$divisions.reportStatusEnum.enum_03.value,
        this.$divisions.reportStatusEnum.enum_05.value,
        this.$divisions.reportStatusEnum.enum_10.value,
        this.$divisions.reportStatusEnum.enum_15.value,
        this.$divisions.reportStatusEnum.enum_16.value,
      ],
      commentPermissionList: [
        {
          name: '管理部コメント',
          permissions: {
            code: 'DWR03G03_MD_CMT',
            group: this.$options.name,
          },
          role: 'mgtdpt',
          preprop: 'preManageComment',
          offprop: 'officalManageComment',
          preDate: 'preManageConfrimDate',
          offDate: 'officalManageConfrimDate',
        },
        {
          name: 'LCコメント',
          permissions: {
            code: 'DWR03G03_LC_CMT',
            group: this.$options.name,
          },
          role: 'lc',
          preprop: 'preLcComment',
          offprop: 'officalLcComment',
          offDate: 'officalLcConfrimDate',
        },
        {
          name: ' PS課コメント',
          permissions: {
            code: 'DWR03G03_PS_CMT',
            group: this.$options.name,
          },
          role: 'ps',
          preprop: 'prePsComment',
          offprop: 'officalPsComment',
          preDate: 'prePsConfrimDate',
          offDate: 'officalPsConfrimDate',
        },
      ],
      btnPermissionList: [
        {
          name: '差し戻し',
          permissions: {
            code: 'DWR03G03_MD_SB',
            group: this.$options.name,
          },
          role: 'mgtdpt',
          activeClass: 'back_btn_active',
          icon: 'cha',
          iconClass: 'cha_icon',
          value: this.$divisions.reportStatusEnum.enum_04.value,
        },
        {
          name: '確認',
          permissions: {
            code: 'DWR03G03_PS_CFM',
            group: this.$options.name,
          },
          role: 'ps',
          activeClass: 'confirm_btn_active',
          icon: 'dui',
          iconClass: 'dui_icon',
          value: this.$divisions.reportStatusEnum.enum_03.value,
        },
        {
          name: '確認',
          permissions: {
            code: 'DWR03G03_MD_CFM',
            group: this.$options.name,
          },
          role: 'mgtdpt',
          activeClass: 'confirm_btn_active',
          icon: 'dui',
          iconClass: 'dui_icon',
          value: this.$divisions.reportStatusEnum.enum_05.value,
        },
        {
          name: '確認',
          permissions: {
            code: 'DWR03G03_LC_CFM',
            group: this.$options.name,
          },
          role: 'lc',
          activeClass: 'confirm_btn_active',
          icon: 'dui',
          iconClass: 'dui_icon',
          value: this.$divisions.reportStatusEnum.enum_11.value,
        },
      ],
      reportId: null,
      reportFormat: null,
      reportStatusLimit: false,
      reportFormatStatus: false,
      reportBaseInfo: {},
      fileList: [],
      workNoList: [],
      mbuildList: [],
      readOnly: false,
      // 不具合No選択
      errorSelectDialogVisible: false,
      // ///////////////////////////////////////
      workNo: null,
      setDefFormData: null,
      itemDetailCd: null,
      clone: {},
      roomListbox: [],
      isEquipment: false,
      inspectionList1CdList: [],
      inspectionList2CdList: [],
      inspectionList3CdList: [],
      currentBascInfo: null,
      preBasicInfo: null,
      reportNo: null,
      showcomment: false,
      comList: [],
      reportStatusCode: null,
    }
  },
  computed: {
    username() {
      return this.$store.getters['user/username']
    },
    requestDestName() {
      return this.$store.getters['user/requestDestName']
    },
    userIdentity() {
      return this.$store.getters['user/userIdentity']
    },
    delSvgShow() {
      let reportLimitList = [
        this.$divisions.reportStatusEnum.enum_21.value,
        this.$divisions.reportStatusEnum.enum_22.value,
      ]
      if (reportLimitList.includes(this.reportStatusCode)) {
        return false
      } else {
        return true
      }
    },
  },
  watch: {
    showBtn: {
      handler(val) {
        if (!val) {
          this.$nextTick(() => {
            if (this.$refs.vabFile) {
              this.$refs.vabFile.view = true
            }
            this.btnRight = []
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {},
  methods: {
    async initMasterData() {
      //（共通）作業情報取得 （今回報告書，前回報告情報）
      const infoList = await getReportInfo(this.reportNo)
      if (infoList.length) {
        this.currentBascInfo = infoList[0]
        if (infoList.length > 1) {
          this.preBasicInfo = infoList[1] ?? null
        }
        this.$nextTick(() => {
          // 基本情報
          if (this.$refs.BasicInfoRef) {
            this.$refs.BasicInfoRef.setBaicInfo(
              this.currentBascInfo,
              this.preBasicInfo
            )
          }
        })
      }
      // 報告書パターンを取得する
      await this.getParams()
      // 作業No
      const workNoList = await getWorkNoList(this.reportNo)
      if (workNoList) {
        this.workNoList = workNoList
      }
      // 棟リスト検索
      const mbuildList = await getmBuildList(this.currentBascInfo.buildingCd)
      if (mbuildList && mbuildList.length) {
        this.mbuildList = mbuildList.filter((item) => item.bldgcd != '  ')
      }
      // 報告書基本RC
      if (this.reportId) {
        await this.getReportRcInfo()
        // if (
        //   this.isEqualCodeEnum(
        //     this.reportFormat,
        //     this.$divisions.reportFormatEnum.enum_1
        //   ) &&
        //   this.isEqualCodeEnum(
        //     this.reportBaseInfo.preReportStatus,
        //     this.$divisions.reportStatusEnum.enum_05
        //   )
        // ) {
        //   this.form.officalPartenrSubmitDate = this.reportBaseInfo
        //     ?.officalPartenrSubmitDate
        //     ? this.reportBaseInfo?.officalPartenrSubmitDate
        //     : this.$dayjs().format(this.$const.dateFormatYYYYMMDD)
        // }
      } else {
        // if (
        //   this.isEqualCodeEnum(
        //     this.reportFormat,
        //     this.$divisions.reportFormatEnum.enum_1
        //   )
        // ) {
        //   this.form.prePartenrSubmitDate = this.$dayjs().format(
        //     this.$const.dateFormatYYYYMMDD
        //   )
        // }
        // if (
        //   this.isEqualCodeEnum(
        //     this.reportFormat,
        //     this.$divisions.reportFormatEnum.enum_2
        //   )
        // ) {
        //   this.form.officalPartenrSubmitDate = this.$dayjs().format(
        //     this.$const.dateFormatYYYYMMDD
        //   )
        // }
      }
      //報告書 FileList
      await this.initFileList()
      this.setBtnName()
      this.setcommentList()
      this.$nextTick(() => {
        // 提出方法
        if (this.$refs.legalPostsendFlgRef) {
          this.$refs.legalPostsendFlgRef[0].setValue(
            this.reportBaseInfo?.legalPostsendFlg
          )
        }
      })
    },
    async getParams() {
      // 報告書パターンを取得する
      let res = null
      if (this.workSpecCd) {
        res = await urgeAndMailOneByParams(this.itemDetailCd, this.workSpecCd)
      } else {
        res = await urgeAndMailOneByParamsOne(this.itemDetailCd)
      }
      if (res) {
        this.setDefFormData = res
        this.reportFormat = res.reportFormat
      }
    },
    // 報告書基本RC
    async getReportRcInfo() {
      this.reportBaseInfo =
        this.currentBascInfo?.reportIdModel ??
        (await getReportRcInfo(this.reportId))
      this.form.preManageComment = null // 速報版管理部コメント
      this.form.officalManageComment = null // 正式版管理部コメント
      this.form.preLcComment = null
      this.form.officalLcComment = null
      this.form.prePsComment = null // 速報版PS課コメント
      this.form.officalPsComment = null // 正式版PS課コメント
      this.form.legalPostsendFlg = this.reportBaseInfo.legalPostsendFlg
      this.form.legalSubmitDate = this.reportBaseInfo.legalSubmitDate
      this.form.duplicateConfrimDate = this.reportBaseInfo.duplicateConfrimDate
      this.form.preReportStatus = this.reportBaseInfo.preReportStatus
      this.form.officalReportStatus = this.reportBaseInfo.officalReportStatus
      this.form.prePsConfrimDate = this.reportBaseInfo.prePsConfrimDate
      this.form.officalPsConfrimDate = this.reportBaseInfo.officalPsConfrimDate
      this.form.prePartenrSubmitDate = this.reportBaseInfo.prePartenrSubmitDate
      this.form.officalManageConfrimDate =
        this.reportBaseInfo.officalManageConfrimDate
      this.form.officalLcConfrimDate = this.reportBaseInfo.officalLcConfrimDate
      this.form.officalPartenrSubmitDate =
        this.reportBaseInfo.officalPartenrSubmitDate
      // 調整履歴の初期化
      if (!this.$baseLodash.isEmpty(this.reportBaseInfo.commentHistory)) {
        let commentList = JSON.parse(this.reportBaseInfo.commentHistory)
        commentList.forEach((itemComment) => {
          if (itemComment.company) {
            itemComment.company = this.$divisions.adjSourceClassEnum.enum_2.text
          } else {
            itemComment.partner = this.$divisions.adjSourceClassEnum.enum_1.text
          }
        })
        this.$refs.vabMessage.setList(JSON.stringify(commentList))
      }
    },
    // 報告書 FileList
    async initFileList() {
      this.setFileBtnList()
      if (this.reportId) {
        const bookFileList = await getReportFile({
          reportId: this.reportId,
        })
        bookFileList.filter((item) => {
          if (
            item.reportTypeFlag ==
            this.$divisions.reportTypeFlagEnum.enum_1.value
          ) {
            this.reportStatusCode = item.reportStatus
          }
          this.reportFileRcModelList.filter((fileItem) => {
            if (fileItem.reportTypeFlag == item.reportTypeFlag) {
              fileItem.icon = 'dui'
              fileItem.color = '#0060C2'
              fileItem.prestatusName = this.getEnumText(
                this.reportBaseInfo.preReportStatus,
                this.$divisions.reportStatusEnum
              )
              // 差し戻し
              if (
                this.isEqualCodeEnum(
                  this.reportBaseInfo.preReportStatus,
                  this.$divisions.reportStatusEnum.enum_04
                )
              ) {
                fileItem.icon = 'cha'
                fileItem.color = '#C90022'
              }

              fileItem.offstatusName = this.getEnumText(
                this.reportBaseInfo.officalReportStatus,
                this.$divisions.reportStatusEnum
              )
              if (
                this.isEqualCodeEnum(
                  this.reportBaseInfo.officalReportStatus,
                  this.$divisions.reportStatusEnum.enum_04
                )
              ) {
                fileItem.icon = 'cha'
                fileItem.color = '#C90022'
              }
              fileItem.list[0].fileList.push({
                ...item,
                btnName: '上書き',
                delCheck: true,
              })
            }
          })
        })
      }
      this.$refs.vabFile.setList(this.reportFileRcModelList, this)
    },
    // 報告書FileListset
    setFileList(res, row) {
      this.reportFileRcModelList.filter((item) => {
        if (item.reportTypeFlag == row.reportTypeFlag) {
          res.btnName = '上書き'
          res.delCheck = true
          res.reportTypeFlag = row?.reportTypeFlag
          item.list[0].fileList.push(res)
        }
      })
    },
    // 報告書FileListRow
    setRowFileList(resbox, row, file, index) {
      this.reportFileRcModelList.filter((item) => {
        if (item.reportTypeFlag == row.reportTypeFlag) {
          if (file.fileId) {
            let data = this.$baseLodash.cloneDeep(file)
            data.operationType = this.$divisions.operationTypeEnum.enum_D.value
            item.list[0].fileList.push(data)
          }
          item.list[0].fileList.filter((res, fIndex) => {
            if (fIndex == index) {
              res.btnName = '上書き'
              res.delCheck = true
              res.submitSourceClass = resbox.submitSourceClass
              res.fileName = resbox?.fileName
              res.filePath = resbox?.filePath
              res.operationType = resbox?.operationType
              res.createTime = resbox?.createTime
              res.createDate = resbox?.createDate
              res.reportStatus = resbox?.reportStatus
              res.reportStatusDate = resbox?.reportStatusDate
              res.reportTypeFlag = row?.reportTypeFlag
              if (res.fileId) {
                res.fileId = null
                res.reportId = null
              }
            }
          })
        }
      })
    },
    // ファイルを削除
    deleteBookFileList(row, index, file) {
      let reportFileRcModelList = this.$baseLodash.cloneDeep(
        this.reportFileRcModelList
      )
      reportFileRcModelList.filter((item, roindex) => {
        if (item.reportTypeFlag == row.reportTypeFlag) {
          if (file.fileId) {
            item.list[0].fileList[index] = {
              ...row,
              ...file,
            }
          } else {
            item.list[0].fileList.splice(index, 1)
          }
          this.$set(this.reportFileRcModelList, roindex, item)
        }
      })
    },
    // 報告書FileList
    setFileBtnList() {
      this.reportFileRcModelList = []
      let defaultItem = {
        reportNo: this.reportNo,
        reportId: this.reportId,
        buildingCd: this.currentBascInfo.buildingCd,
        btnDisabled: this.readOnly,
        officalReportStatus: this.reportBaseInfo?.officalReportStatus,
        preReportStatus: this.reportBaseInfo?.preReportStatus,
        btnName: '一括アップロード',
        uploadUrl: '/api/reportFileRc/uploadFile',
        uploadAllUrl: '/api/reportFileRc/uploadBatchFile',
      }
      let officalReportItem = {
        ...defaultItem,
        requiredFlg: '1',
        reportTypeFlag: this.$divisions.reportTypeFlagEnum.enum_1.value,
        docName: '正式版',
        btnName: '一括アップロード',
        uploadUrl: '/api/reportFileRc/uploadFile',
        uploadAllUrl: '/api/reportFileRc/uploadBatchFile',
        list: [
          {
            btnName: '追加アップロード',
            fileList: [],
          },
        ],
      }
      let preReportItem = {
        ...defaultItem,
        requiredFlg: '2',
        docName: '速報版',
        reportTypeFlag: this.$divisions.reportTypeFlagEnum.enum_0.value,
        list: [
          {
            btnName: '追加アップロード',
            fileList: [],
          },
        ],
      }
      // 速報版＋正式版
      if (
        this.isEqualCodeEnum(
          this.reportFormat,
          this.$divisions.reportFormatEnum.enum_1
        )
      ) {
        this.reportFileRcModelList.push(preReportItem)
        this.reportFileRcModelList.push(officalReportItem)
      }
      // 正式版
      if (
        this.isEqualCodeEnum(
          this.reportFormat,
          this.$divisions.reportFormatEnum.enum_2
        )
      ) {
        this.reportFileRcModelList.push(officalReportItem)
      }
    },
    // ①進捗管理リンクは表示される条件はprogess_target_classがnullではないの場合、進捗管理リンクを表示される。
    //②リンクをクリックすると、対象画面へ遷移する。
    //a.progess_target_class="1" 画面ID：DWR03G09の画面へ遷移
    //b.progess_target_class="2" 画面ID：DWR03G10の画面へ遷移
    //c.progess_target_class="3" 画面ID：DWR03G13の画面へ遷移
    //d.progess_target_class="4" 画面ID：DWR03G14の画面へ遷移
    //e.progess_target_class="5" 画面ID：DWR03G11の画面へ遷移
    //Df.progess_target_class="6" 画面ID：DWR03G12の画面へ遷移
    goEntryManagementPage() {
      switch (this.reportBaseInfo.progessTargetClass) {
        case this.$divisions.progessTargetClassEnum.enum_1.value:
          this.$routerPush({
            path: '/reportIncomingManagement/DWR03G09',
            query: {
              popupData: {
                ...this.reportBaseInfo,
                workNo: this.reportBaseInfo.reportNo,
              },
              openPage: true,
            },
          })
          break
        case this.$divisions.progessTargetClassEnum.enum_2.value:
          this.$routerPush({
            path: '/reportIncomingManagement/DWR03G10',
            query: {
              popupData: {
                ...this.reportBaseInfo,
                workNo: this.reportBaseInfo.reportNo,
              },
              openPage: true,
            },
          })
          break
        case this.$divisions.progessTargetClassEnum.enum_3.value:
          this.$routerPush({
            path: '/reportIncomingManagement/DWR03G13',
            query: {
              popupData: {
                ...this.reportBaseInfo,
                workNo: this.reportBaseInfo.reportNo,
              },
              openPage: true,
            },
          })
          break
        case this.$divisions.progessTargetClassEnum.enum_4.value:
          this.$routerPush({
            path: '/reportIncomingManagement/DWR03G14',
            query: {
              popupData: {
                ...this.reportBaseInfo,
                workNo: this.reportBaseInfo.reportNo,
              },
              openPage: true,
            },
          })
          break
        case this.$divisions.progessTargetClassEnum.enum_5.value:
          this.$routerPush({
            path: '/reportIncomingManagement/DWR03G11',
            query: {
              popupData: {
                ...this.reportBaseInfo,
                workNo: this.reportBaseInfo.reportNo,
              },
              openPage: true,
            },
          })
          break
        case this.$divisions.progessTargetClassEnum.enum_6.value:
          this.$routerPush({
            path: '/reportIncomingManagement/DWR03G12',
            query: {
              popupData: {
                ...this.reportBaseInfo,
                workNo: this.reportBaseInfo.reportNo,
              },
              openPage: true,
            },
          })
          break
      }
    },

    // 通知先
    getNotifyList(list) {
      this.form.dlnDestination = JSON.stringify(list)
    },
    // 不具合photo
    async getDefectPhotos(id) {
      const res = await getDefectPhoto({
        defectId: id,
      })
      return res
    },
    // 棟名查询
    getSectionName(sectionCd) {
      const chooseOne = this.$baseLodash.find(this.mbuildList, (o) => {
        return o.bldgcd == sectionCd
      })
      if (!this.$baseLodash.isUndefined(chooseOne)) {
        return chooseOne.blgsbldgkj
      }
      return null
    },
    // 棟名代入
    handlemBuildListChange(row) {
      this.$nextTick(() => {
        const chooseOne = this.$baseLodash.find(this.mbuildList, (o) => {
          return o.bldgcd == row.reportSectionCd
        })
        if (
          (!this.$baseLodash.isEmpty(row.sectionCd) ||
            !this.$baseLodash.isEmpty(row.reportSectionCd)) &&
          !this.$baseLodash.isUndefined(chooseOne?.blgsbldgkj)
        ) {
          row.blgsnmkj = chooseOne.blgsbldgkj
        } else {
          row.blgsnmkj = null
        }
      })
    },
    isShow(item, index) {
      this.form.reportDetailRcModelList[index].workFold =
        !this.form.reportDetailRcModelList[index].workFold
    },
    getReportRequestData() {
      // let data = {}
      // if (!this.reportId) {
      //   if (!this.preBasicInfo || !this.preBasicInfo?.reportNo) {
      //     data.currentReportNoFlg = true
      //     data.reportNo = this.reportNo ?? this.currentBascInfo.workNo
      //   } else {
      //     data.currentReportNoFlg = false
      //     data.reportNo = this.preBasicInfo.reportNo || null
      //   }
      // } else {
      //   data.currentReportNoFlg = true
      //   data.reportNo = this.reportNo ?? this.currentBascInfo.workNo
      // }
      return { reportNo: this.reportNo, currentReportNoFlg: true }
    },
    setReportStatus(data) {
      let stateList = [
        this.$divisions.reportStatusEnum.enum_00.value, // 未提出
        this.$divisions.reportStatusEnum.enum_01.value, // 協力会社へ催促中
      ]
      // 速報版報告書状況
      if (
        (this.$baseLodash.isNull(data.preReportStatus) ||
          stateList.includes(data.preReportStatus)) &&
        this.checkOtherModeList(data)
      ) {
        data.preReportStatus = this.$divisions.reportStatusEnum.enum_02.value
      }

      // 正式版報告書状況
      if (
        (this.$baseLodash.isNull(data.officalReportStatus) ||
          stateList.includes(data.officalReportStatus)) &&
        this.getofficalReporFiletList(data.reportFileRcModelList)
      ) {
        data.officalReportStatus =
          this.$divisions.reportStatusEnum.enum_02.value
      }
      if (this.$baseLodash.isNull(data.officalReportStatus)) {
        data.officalReportStatus =
          this.$divisions.reportStatusEnum.enum_00.value
      }
    },
    checkOtherModeList(data) {
      let temp = false
      Object.keys(data).filter((item) => {
        if (item.endsWith('List') && data[item].length > 0) {
          temp = true
        }
      })
      return temp
    },
    getofficalReporFiletList(reportFileRcModelList) {
      if (reportFileRcModelList.length == 0) return false
      return (
        reportFileRcModelList.filter((item) => {
          item.reportTypeFlag == this.$divisions.reportTypeFlagEnum.enum_1
        }).length > 0
      )
    },
    changeSumbmitBtnName() {
      // report_format=1
      // 速報版
      // eslint-disable-next-line no-irregular-whitespace
      // 速報版報告書状況：null、00、01、04の場合、画面上に提出ボタンを表示する。提出ボタンを押すと、速報版報告書状況：02　を設定する
      // 速報版報告書状況：02の場合、更新ボタンを表示する。
      // 速報版報告書状況：03、05の場合、更新ボタンおよび特記事項は非表示する
      // 正式版
      // eslint-disable-next-line no-irregular-whitespace
      // 速報版報告書状況:05 and 正式版報告書状況：null、00、01、04の場合、画面上に提出ボタンを表示する。提出ボタンを押すと、正式版報告書状況：02　を設定する
      // 正式版報告書状況：02の場合、更新ボタンを表示する。
      // 正式版報告書状況：03、05、10、11、15、16の場合、更新ボタンおよび特記事項は非表示する
      // report_format=2
      // 正式版
      // eslint-disable-next-line no-irregular-whitespace
      // 正式版報告書状況：null、00、01、04の場合、画面上に提出ボタンを表示する。提出ボタンを押すと、正式版報告書状況：02　を設定する
      // 正式版報告書状況：02の場合、更新ボタンを表示する。
      // 正式版報告書状況：03、05、10、11、15、16の場合、更新ボタンおよび特記事項は非表示する

      // report_format=1

      if (
        this.isEqualCodeEnum(
          this.reportFormat,
          this.$divisions.reportFormatEnum.enum_1
        )
      ) {
        return this.getTmpe1Data()
      } else if (
        this.isEqualCodeEnum(
          this.reportFormat,
          this.$divisions.reportFormatEnum.enum_2
        )
      ) {
        return this.getTmpe2Data()
      } else {
        return {}
      }
    },
    getTmpe2Data() {
      let stateList = [
        null,
        this.$divisions.reportStatusEnum.enum_00.value,
        this.$divisions.reportStatusEnum.enum_01.value,
        this.$divisions.reportStatusEnum.enum_04.value,
      ]
      let stateList02 = [
        this.$divisions.reportStatusEnum.enum_02.value,
        this.$divisions.reportStatusEnum.enum_11.value,
      ]
      let ors = this.form.officalReportStatus ?? null

      if (stateList.includes(ors)) {
        return {
          btnName: '提出',
          key: 'officalReportStatus',
          value: this.$divisions.reportStatusEnum.enum_02.value,
          show: true,
        }
      }
      if (stateList02.includes(ors)) {
        return {
          btnName: '更新',
          show: true,
        }
      }
      let orsList = [
        this.$divisions.reportStatusEnum.enum_03.value,
        this.$divisions.reportStatusEnum.enum_05.value,
        this.$divisions.reportStatusEnum.enum_10.value,
        // this.$divisions.reportStatusEnum.enum_11.value,
        this.$divisions.reportStatusEnum.enum_15.value,
        this.$divisions.reportStatusEnum.enum_16.value,
      ]
      if (orsList.includes(ors)) {
        return {
          btnName: '更新',
          show: false,
        }
      }
    },
    getTmpe1Data() {
      let prs = this.form.preReportStatus ?? null
      let ors = this.form.officalReportStatus ?? null
      let stateList = [
        null,
        this.$divisions.reportStatusEnum.enum_00.value,
        this.$divisions.reportStatusEnum.enum_01.value,
        this.$divisions.reportStatusEnum.enum_04.value,
      ]
      let stateList02 = [
        this.$divisions.reportStatusEnum.enum_02.value,
        this.$divisions.reportStatusEnum.enum_11.value,
      ]
      let prsList = [
        this.$divisions.reportStatusEnum.enum_03.value,
        this.$divisions.reportStatusEnum.enum_05.value,
      ]
      let orsList = [
        this.$divisions.reportStatusEnum.enum_03.value,
        this.$divisions.reportStatusEnum.enum_05.value,
        this.$divisions.reportStatusEnum.enum_10.value,
        // this.$divisions.reportStatusEnum.enum_11.value,
        this.$divisions.reportStatusEnum.enum_15.value,
        this.$divisions.reportStatusEnum.enum_16.value,
      ]

      let prsTemp = stateList.includes(prs)
      if (prsTemp) {
        return {
          btnName: '提出',
          key: 'preReportStatus',
          value: this.$divisions.reportStatusEnum.enum_02.value,
          show: true,
        }
      }
      let orsTemp =
        stateList.includes(ors) &&
        this.isEqualCodeEnum(prs, this.$divisions.reportStatusEnum.enum_05)
      if (orsTemp) {
        return {
          btnName: '提出',
          key: 'officalReportStatus',
          value: this.$divisions.reportStatusEnum.enum_02.value,
          show: true,
        }
      }
      if (stateList02.includes(ors) || stateList02.includes(prs)) {
        return {
          btnName: '更新',
          show: true,
        }
      }
      if (prsList.includes(prs) || orsList.includes(prs)) {
        return {
          btnName: '更新',
          show: false,
        }
      }
    },
    setBtnName() {
      this.btnData = this.changeSumbmitBtnName()
      if (this.btnRight.length > 0 && this.showBtn) {
        this.btnRight[0].name = this.btnData.btnName
        this.btnRight[0].hidden = !this.btnData.show
      }
    },
    setcommentList() {
      let reportFormat = this.reportFormat
      let preReportStatus = this.form.preReportStatus
      let officalReportStatus = this.form.officalReportStatus
      // let reportId = this.reportId
      let preData = {
        type: 'pre',
      }
      let offData = {
        type: 'off',
      }
      // let stateList = [
      //   null,
      //   this.$divisions.reportStatusEnum.enum_00.value,
      //   this.$divisions.reportStatusEnum.enum_01.value,
      // ]
      let statePerList = [
        null,
        this.$divisions.reportStatusEnum.enum_00.value,
        this.$divisions.reportStatusEnum.enum_01.value,
        this.$divisions.reportStatusEnum.enum_02.value,
        this.$divisions.reportStatusEnum.enum_03.value,
        this.$divisions.reportStatusEnum.enum_04.value,
      ]
      // reportFormat 1
      // 速报版
      //   日期 有值显示值，没值显示入力框（默认值）

      // 速报版状态小于05
      // 正式版
      // 日期，radio 显示为不可编辑

      // 正式版
      // 速报版状态是05
      // 日期 有值显示值,没值显示入力框（默认值）
      // radio 可以编辑

      // reportformat 2
      // 速报版
      // 日期，状态 显示为-

      // 正式版
      // 日期 有值显示值，没值显示入力框（默认值)
      if (
        this.isEqualCodeEnum(
          reportFormat,
          this.$divisions.reportFormatEnum.enum_1
        )
      ) {
        offData.raido = true
        if (this.form?.prePartenrSubmitDate) {
          preData.prePartenrSubmitDate = this.form.prePartenrSubmitDate
        } else {
          preData.picker = true
          this.form.prePartenrSubmitDate = this.$dayjs().format(
            this.$const.dateFormatYYYYMMDD
          )
        }
        preData.statusName = this.getEnumText(
          preReportStatus,
          this.$divisions.reportStatusEnum
        )

        if (statePerList.includes(preReportStatus)) {
          offData.picker = true
          offData.raido = true
          offData.disabled = true
        }
        if (
          this.isEqualCodeEnum(
            preReportStatus,
            this.$divisions.reportStatusEnum.enum_05
          )
        ) {
          if (this.form?.officalPartenrSubmitDate) {
            offData.officalPartenrSubmitDate =
              this.form?.officalPartenrSubmitDate
          } else {
            offData.picker = true
            offData.raido = true
            this.form.officalPartenrSubmitDate = this.$dayjs().format(
              this.$const.dateFormatYYYYMMDD
            )
          }
        }
        offData.statusName = this.getEnumText(
          officalReportStatus,
          this.$divisions.reportStatusEnum
        )
        // if (!reportId) {
        //   preData.picker = true
        //   preData.statusName = this.getEnumText(
        //     '00',
        //     this.$divisions.reportStatusEnum
        //   )
        // } else {
        //   preData.picker = false
        //   preData.prePartenrSubmitDate = this.form.prePartenrSubmitDate
        //   preData.statusName = this.getEnumText(
        //     preReportStatus,
        //     this.$divisions.reportStatusEnum
        //   )
        // }
        // if (!reportId) {
        //   offData.statusName = '-'
        //   offData.legalPostsendFlg = '-'
        //   offData.officalPartenrSubmitDate = '-'
        // } else {
        //   offData.statusName = this.getEnumText(
        //     officalReportStatus,
        //     this.$divisions.reportStatusEnum
        //   )
        //   if (
        //     this.isEqualCodeEnum(
        //       this.form.preReportStatus,
        //       this.$divisions.reportStatusEnum.enum_05
        //     ) &&
        //     stateList.includes(officalReportStatus)
        //   ) {
        //     offData.picker = true
        //     offData.raido = true
        //   } else {
        //     offData.officalPartenrSubmitDate =
        //       this.form.officalPartenrSubmitDate || '-'
        //     offData.raido = true
        //   }
        // }
      } else if (
        this.isEqualCodeEnum(
          reportFormat,
          this.$divisions.reportFormatEnum.enum_2
        )
      ) {
        preData.statusName = '-'
        preData.prePartenrSubmitDate = '-'

        if (this.form?.officalPartenrSubmitDate) {
          offData.officalPartenrSubmitDate = this.form?.officalPartenrSubmitDate
        } else {
          offData.picker = true
          offData.raido = true
          this.form.officalPartenrSubmitDate = this.$dayjs().format(
            this.$const.dateFormatYYYYMMDD
          )
        }

        offData.statusName = this.getEnumText(
          officalReportStatus,
          this.$divisions.reportStatusEnum
        )

        // if (!reportId) {
        //   preData.statusName = '-'
        //   preData.prePartenrSubmitDate = '-'
        // } else {
        //   preData.prePartenrSubmitDate = this.form.prePartenrSubmitDate
        //   preData.statusName = this.getEnumText(
        //     preReportStatus,
        //     this.$divisions.reportStatusEnum
        //   )
        // }

        // if (!reportId) {
        //   offData.picker = true
        //   offData.statusName = this.getEnumText(
        //     '00',
        //     this.$divisions.reportStatusEnum
        //   )
        // } else {
        //   offData.statusName = this.getEnumText(
        //     officalReportStatus,
        //     this.$divisions.reportStatusEnum
        //   )
        //   offData.officalPartenrSubmitDate = this.form.officalPartenrSubmitDate
        // }
      }
      this.comList.push(preData)
      this.comList.push(offData)
    },
    // 不具合No選択
    failureNoDialog(row, index, sonIndex) {
      if (!this.showBtn) return
      if (
        this.$baseLodash.isEmpty(row.inspectionList1Cd) ||
        this.$baseLodash.isEmpty(row.inspectionList2Cd) ||
        this.$baseLodash.isEmpty(row.inspectionList3Cd)
      ) {
        return
      }
      this.novisable = true
      this.$refs.failureNo.getRow(row, index, sonIndex)
    },
  },
}
